export const locale = {
    lang: 'pt',
    data: {
        LIST_CLINIC_MESSAGE: {
            TITLE: 'Mensagem',
            RESOLVE: 'Resolver',
            REOPEN: 'Reabrir',
            EMPTY_MESSAGE: {
                TITLE: 'Nenhuma mensagem selecionada',
                DESCRIPTION: 'Seleciona o pedido ao lado',
            },
            EMPTY_ORDER_MESSAGE: 'Nenhum pedido encontrado',
            EMPTY_ORDER_SEARCH_MESSAGE: 'Pesquise um pedido',
            REMAKE_TYPE: {
                REMAKE: 'Remake',
                REMAKE_INITIAL: 'R',
                ADJUSTMENT: 'Adjustment',
                ADJUSTMENT_INITIAL: 'A',
            },
            EMPTY_PATIENT: 'Paciente não definido',
            DELETED_MESSAGE: 'Mensagem apagada',
            COMPLETE_DATE_FORMAT: "dd 'de' MMMM 'de' yyyy",
            TAGS: {
                OPEN: 'Em aberto',
                NOT_READ: 'Não lidas',
                RESOLVED: 'Resolvidas',
            },
            FORM: {
                FIELDS: {
                    MESSAGE: 'Digite sua mensagem',
                    SEARCH_ORDER_MESSAGE: 'Busca pelo número do pedido, cliente ou paciente',
                },
            },
            MAT_MENU: {
                FILES: 'Arquivos',
                PHOTOS_AND_VIDEOS: 'Fotos e vídeos',
            },
            TOASTR: {
                ERRORS: {
                    PHOTO_VIDEO: 'É permitido apenas imagens ou vídeos.',
                    FILE: 'É permitido apenas arquivos diferentes de imagens ou vídeos.',
                    MAX_FILE: 'São permitidos no máximo 15 arquivos.',
                    MAX_FILE_SIZE: 'Não é permitido o envio de arquivos com mais de 150 MB.',
                },
            },
            MODAL: {
                GENERAL: {
                    BUTTONS: {
                        CONFIRM: 'Enviar',
                        CANCEL: 'Cancelar',
                    },
                },
                PREVIEW: {
                    TITLE: 'Pré-visualizar',
                },
                IMAGE: {
                    TITLE: 'Visualizar imagem',
                },
            },
            DIALOG: {
                GENERAL: {
                    BUTTONS: {
                        CANCEL: 'Cancelar',
                        REOPEN: 'Reabrir',
                    },
                },
                REOPEN: {
                    TITLE: 'Reabrir conversa',
                    DESCRIPTION: 'Tem certeza que deseja reabrir essa conversa?',
                },
            },
        },
    },
};
